import type { Metadata, Viewport } from 'next';

/**
 * Was beide Root-Layouts tragen — die Single-Page-App (`(spa)`) und die
 * Server-Seiten (`(seiten)`). Zwei Root-Layouts braucht es, weil eine
 * Server-Seite `<html lang>` aus ihrer Adresse setzt, die App erst im Browser;
 * der Rest ist derselbe und steht deshalb hier (vorher in `index.html`).
 */

/**
 * Favicons — quadratisch und in Vielfachen von 48 px, wie Google sie für die
 * Trefferliste verlangt. Bis 25.10.2026 waren es 67×65 (PNG) und 32×31 (ICO):
 * nicht quadratisch, also zeigte Google in der mobilen Trefferliste ein
 * Standardsymbol statt des Wirbels. Alle Dateien sind aus dem Wirbel in
 * `public/logo.png` geschnitten; `backend/tests/test_favicon_canon.py` hält
 * Grössen und Angaben hier gegen die Dateien.
 */
export const ICONS: Metadata['icons'] = {
  icon: [
    { url: '/favicon.ico', type: 'image/x-icon', sizes: '16x16 32x32 48x48' },
    { url: '/icon-48.png', type: 'image/png', sizes: '48x48' },
    { url: '/icon-96.png', type: 'image/png', sizes: '96x96' },
    { url: '/icon.png', type: 'image/png', sizes: '192x192' },
  ],
  apple: [{ url: '/apple-touch-icon.png', sizes: '180x180' }],
};

export const VIEWPORT: Viewport = {
  width: 'device-width',
  initialScale: 1,
  themeColor: '#1a1a2e',  // farbe-bleibt: Meta-Angabe braucht einen echten Farbwert
  // Die App ist hell, solange die Person nichts anderes wählt — die
  // Systemeinstellung allein schaltet nie auf dunkel (Dunkelmodus nur optional,
  // 07.10.2026). Ohne diese Angabe faerbt WebKit auf einem iPhone im
  // Dunkelmodus die Formularfelder eigenmaechtig dunkel ein. Wer dunkel wählt,
  // bekommt `color-scheme: dark` über `:root[data-theme='dark']`.
  colorScheme: 'light',
};

// Grundstil im <head>, wie bisher inline in index.html. Er steht HINTER dem
// Stylesheet und schlägt dessen `body`-Regel — deshalb keine Farben und keine
// Schrift mehr hier (bis 10/2026: feste helle Werte, im Dunkelmodus blieb jede
// geerbte Schrift dunkel, und 'Inter Fallback' fehlte). Das Stylesheet
// blockiert das Rendern ohnehin; Farben und Schrift kommen aus index.css.
export const GRUNDSTIL = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { line-height: 1.5; }
`;
